import icons from './icons.json'
import { dialogLabels } from './zencare'
import type { BenefitStoreContext } from '~/stores'

export const zencare_plus: BenefitStoreContext[string] = {
	description:
		'Get access to comprehensive, high-quality medical care that covers all of your health needs and more.',
	product_title: "Prioritize your team's health and productivity with our comprehensive coverage.",
	card_label:
		'Premium healthcare with extensive treatments. Prioritize health and productivity. Tailored coverage for mcg_price per staff.',
	dialogLabels,

	short_benefits: {
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				'Renewing your plan consistently helps you keep all the benefits without losing them.',
				'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
				'You can use the telemedicine option by simply calling a doctor via the platform.',
				'This is an insurance product and it adheres to standard insurance procedures.',
				'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon renewal, the payment will be deducted from your registered card or funded wallet. You can cancel the auto-renewal at any time by contacting our support team.',
				`You can start using your benefits ${WAITING_PERIOD} hours after receiving your HMO ID.`,
				'Please note that the plan does not cover certain exclusions.',
				'When you or your staff arrive at any of the hospitals, tell them you are from Bastion. If you experience any delay, call 09070008899'
			]
		},
		'Total Hospitals': {
			icon: icons.hospital,
			isOpen: false,
			value: [{ text: 'Your staff gains access to over 1200 hospitals across Nigeria.' }],
			key: 'hospital'
		},
		'Your Business Will Enjoy': {
			icon: icons.business,
			isOpen: false,
			value: [
				'Treatment of everyday illnesses, like malaria and more.',
				'Coverage for general and specialist consultations, including 24-hour toll-free calls with healthcare professionals.',
				'Access to minor, intermediate, and major surgeries up to ₦500,000.',
				'Coverage for accident and emergency care services, including ambulance and ICU services.',
				'Extensive treatment options for chronic conditions, medication, and hospital admissions.',
				'Coverage for delivery and ante-natal care, including assisted deliveries and c-sections.',
				'A digital HMO ID for each person.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Access to general and specialist consultations.',
				'24 hours telemedicine services: chat with doctors and nurses.',
				'Coverage for hospital admissions and laboratory tests for chronic conditions.',
				'Fertility investigation and treatments of up to ₦45,000 annually.',
				'Coverage for family planning services, contraceptives and implants.',
				'Immunisation for children (0-5 years) including BCG, OPV, DPT, IPV, Vitamin A, measles, yellow fever, meningitis.',
				'Additional immunisation coverage for 6 years and above, including HPV Vaccine and Hepatitis B.',
				'Ambulance services and resuscitative care for accident and emergency cases, including basic radiological and laboratory investigations needed to stabilise a patient before being moved to the ICU if need be.',
				'Access to Intensive Care Unit (ICU) including comatose patients, ventilator care and more, for up to 3 days.',
				'Coverage for diagnostic services including X-Rays, ultrasounds, CT scans and emergency MRIs.',
				'Coverage for laboratory tests including haematology, chemistry, microbiology, serology.',
				'Semi-private ward admissions, accommodation and feeding for in-patient care, and up to 2 days accommodation for parents whose infants are on admission.',
				'Ear, Nose & Throat (ENT) specialist care coverage.',
				'Access to routine eye tests and up to ₦20,000 coverage for lens or frames annually.',
				'Primary and secondary dental care coverage for up to ₦50,000.',
				'Up to 12 sessions for physiotherapy care, including drugs, annually.',
				'Coverage for minor, intermediate, and major surgeries up to ₦500,000.',
				'Protection for delivery and ante-natal care including assisted deliveries and c-sections.',
				'Neo-natal care including male circumcision and ear piercing, intensive care & life support, incubator care for 10 days up to ₦300,000.',
				'Renal care and dialysis for 6 sessions annually.',
				'Cancer care including consultation, admission, hospice, chemotherapy, and radiotherapy for up to ₦750,000.',
				'Wellness checks including BMI, HIV, hypertension, diabetes, blood group, urinalysis, ECG, ALT/AST, and general physical examinations.',
				'Access to HIV care and treatment services.',
				'Mental health outpatient consultations for up to 6 weeks.',
				'Psychiatry care for outpatient mental illness cases, up to 6 weeks.',
				'10% discount on fitness and nutritional club membership (for non-network gyms).',
				'Network gym access - 2 sessions per week.',
				'After demise care and death cover for up to ₦75,000.',
				'Diagnosis and line of treatment confirmation from secondary/tertiary care centres.'
			],
			need_to_know: [
				'Renewing your plan consistently helps you keep all the benefits without losing them.',
				'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
				'You can use the telemedicine option by simply calling a doctor via the platform.',
				'This is an insurance product and it adheres to standard insurance procedures.',
				'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon renewal, the payment will be deducted from your registered card or funded wallet. You can cancel the auto-renewal at any time by contacting our support team.',
				`You can start using your benefits ${WAITING_PERIOD} hours after receiving your HMO ID.`,
				'Please note that the plan does not cover certain exclusions.',
				'When you or your staff arrive at any of the hospitals, tell them you are from Bastion. If you experience any delay, call 09070008899'
			],
			'How to get covered': [
				'Purchase the plan and add your staff.',
				'Ask the policyholders (your staff) to activate their plans, or do it yourself from your dashboard.',
				'After activation, the e-HMO ID will be automatically generated.',
				`${WAITING_PERIOD} hours after activation, your staff can present their HMO ID at any of the hospitals under the plan to receive healthcare.`
			]
		}
	}
}
